import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const CategoryCard = ({ id, value, handleSave, handleDelete, isUpdating }) => {
  const [categoryValue, setCategoryValue] = useState(value);

  return (
    <div
      style={{
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.5rem',
      }}
    >
      <Form.Control
        placeholder="קטגוריה"
        type="text"
        value={categoryValue}
        onChange={(e) => setCategoryValue(e.target.value)}
      />
      <Button variant="primary" onClick={() => handleSave(id, categoryValue)}>
        שמור
      </Button>
      <Button variant="danger" onClick={handleDelete}>
        מחק
      </Button>
      {isUpdating && <span>טוען...</span>}
    </div>
  );
};

export default CategoryCard;
